export default __webpack_public_path__ + "static/media/transaction.21379e1d.svg";